<script>
  let { addressLength = Math.floor(Math.random() * 4) } = $props();
</script>

<div class="flex bg-white px-4 py-3 rounded-lg text-left justify-between items-center shadow-y-sm">
  <span
    class="h-5 skeleton-gradient animated-skeleton"
    class:w-16={addressLength === 0}
    class:w-32={addressLength === 1}
    class:w-48={addressLength === 2}
    class:w-56={addressLength === 3}
  ></span>
  <span class="w-16 h-4 skeleton-gradient animated-skeleton"></span>
</div>
